export const FETCH_PRODUCT_BUNDLE_PENDING = 'FETCH_PRODUCT_BUNDLE_PENDING';
export const FETCH_PRODUCT_BUNDLE_REJECTED = 'FETCH_PRODUCT_BUNDLE_REJECTED';
export const FETCH_PRODUCT_BUNDLE_FULFILLED = 'FETCH_PRODUCT_BUNDLE_FULFILLED';
export const CLEAR_PRODUCT_BUNDLE = 'CLEAR_PRODUCT_BUNDLE';



// WEBPACK FOOTER //
// ./src/constants/productBundleCampaign.js